import { PrivateInformationBirthdateType } from 'src/features/persons/PersonPrivateInformation/components/EditPrivateInformationForm/hooks';
import { BirthdateInputUnionType } from '../../../common';

type GetNewValueArgsType = {
  previousValue: PrivateInformationBirthdateType;
  inputValue: string;
  inputType: BirthdateInputUnionType;
};

export const getNewValue = ({
  previousValue,
  inputValue,
  inputType,
}: GetNewValueArgsType): PrivateInformationBirthdateType => {
  return {
    ...previousValue,
    [inputType.toLowerCase()]: inputValue === '' ? null : Number(inputValue),
  };
};
